module.exports = __webpack_public_path__ + "img/code-1-1.03e50c6f.png";